@if (!hideTitle) {
  <top-bar-tabs></top-bar-tabs>
}
@if (!hideTitle) {
  <mat-sidenav-container>
    <div class="container">
      <div class="row">
        <ng-container *ngTemplateOutlet="card"></ng-container>
      </div>
    </div>
  </mat-sidenav-container>
}
@if (hideTitle) {
  <ng-container *ngTemplateOutlet="card"></ng-container>
}
<ng-template #card>
  @if (project) {
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          @if (!hideTitle) {
            <span class="title">{{ project.name }} Terms</span>
          }
          @if (hideTitle) {
            <span class="sub-title">Deal Terms</span>
          }
          @if (readOnly !== true) {
            <button
              class="save-button"
              (click)="saveTerms()">
              <mat-icon>save</mat-icon>
            </button>
          }
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (terms) {
          <form mat-form="" class="row gutters align-top" [class]="{editable: readOnly !== true}">
            <ul class="col-md-6">
              <li>
                <span class="label">Credit Delivery End</span>
                @if (readOnly !== true) {
                  <input
                    type="date"
                    name="credit_delivery_end"
                    [(ngModel)]="terms.credit_delivery_end" />
                }
                <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: {
                  value: terms.credit_delivery_end | date: 'MM/dd/yyyy'
                }
              "></ng-container>
            </li>
            <li>
              <span class="label">Year 15 End</span>
              @if (readOnly !== true) {
                <input
                  type="date"
                  name="year_15_end"
                  [(ngModel)]="terms.year_15_end" />
              }
              <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: { value: terms.year_15_end | date: 'MM/dd/yyyy' }
              "></ng-container>
            </li>
            <li>
              <span class="label">Residual Split</span>
              @if (readOnly !== true) {
                <input
                  type="number"
                  name="residual_split"
                  [(ngModel)]="terms.residual_split" />
              }
              <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: {
                  value: terms.residual_split
                    ? terms.residual_split + '%'
                    : terms.residual_split
                }
              "></ng-container>
          </li>
          <li>
            <span class="label">Non-Profit ROFR</span>
            @if (readOnly !== true) {
              <nullable-boolean
                [value]="terms.non_profit_rofr"
                (valueChange)="terms.non_profit_rofr = $event"
              name="non_profit_rofr"></nullable-boolean>
            }
            <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: {
                  value:
                    terms.non_profit_rofr === null
                      ? ''
                      : terms.non_profit_rofr
                      ? 'Yes'
                      : 'No'
                }
              "></ng-container>
        </li>
        <li>
          <span class="label">Non-Profit Start</span>
          @if (readOnly !== true) {
            <input
              type="date"
              name="non_profit_start"
              [(ngModel)]="terms.non_profit_start" />
          }
          <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: { value: terms.non_profit_start | date: 'MM/dd/yyyy' }
              "></ng-container>
        </li>
        <li>
          <span class="label">Non-Profit End</span>
          @if (readOnly !== true) {
            <input
              type="date"
              name="non_profit_end"
              [(ngModel)]="terms.non_profit_end" />
          }
          <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: { value: terms.non_profit_end | date: 'MM/dd/yyyy' }
              "></ng-container>
        </li>
        <li>
          <span class="label">Year 11 ILP Put Option</span>
          @if (readOnly !== true) {
            <input
              type="text"
              name="year_11_ilp_put_option"
              [(ngModel)]="terms.year_11_ilp_put_option" />
          }
          <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: { value: terms.year_11_ilp_put_option }
              "></ng-container>
        </li>
        <li>
          <span class="label">Year 11 ILP Start</span>
          @if (readOnly !== true) {
            <input
              type="date"
              name="year_11_ilp_start"
              [(ngModel)]="terms.year_11_ilp_start" />
          }
          <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: {
                  value: terms.year_11_ilp_start | date: 'MM/dd/yyyy'
                }
              "></ng-container>
      </li>
      <li>
        <span class="label">Year 11 ILP End</span>
        @if (readOnly !== true) {
          <input
            type="date"
            name="year_11_ilp_end"
            [(ngModel)]="terms.year_11_ilp_end" />
        }
        <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: { value: terms.year_11_ilp_end | date: 'MM/dd/yyyy' }
              "></ng-container>
      </li>
      <li>
        <span class="label">Year 15 ILP Put Option</span>
        @if (readOnly !== true) {
          <input
            type="text"
            name="year_15_ilp_put_option"
            [(ngModel)]="terms.year_15_ilp_put_option" />
        }
        <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: { value: terms.year_15_ilp_put_option }
              "></ng-container>
      </li>
      <li>
        <span class="label">Year 15 ILP Start</span>
        @if (readOnly !== true) {
          <input
            type="date"
            name="year_15_ilp_start"
            [(ngModel)]="terms.year_15_ilp_start" />
        }
        <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: {
                  value: terms.year_15_ilp_start | date: 'MM/dd/yyyy'
                }
              "></ng-container>
    </li>
    <li>
      <span class="label">Year 15 ILP End</span>
      @if (readOnly !== true) {
        <input
          type="date"
          name="year_15_ilp_end"
          [(ngModel)]="terms.year_15_ilp_end" />
      }
      <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: { value: terms.year_15_ilp_end | date: 'MM/dd/yyyy' }
              "></ng-container>
    </li>
  </ul>
  <ul class="col-md-6">
    <li>
      <span class="label">Has Exit Taxes Waterfall</span>
      @if (readOnly !== true) {
        <nullable-boolean
          [value]="terms.has_exit_taxes_waterfall"
          (valueChange)="terms.has_exit_taxes_waterfall = $event"
        name="has_exit_taxes_waterfall"></nullable-boolean>
      }
      <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: {
                  value:
                    terms.has_exit_taxes_waterfall === null
                      ? ''
                      : terms.has_exit_taxes_waterfall
                      ? 'Yes'
                      : 'No'
                }
              "></ng-container>
  </li>
  <li>
    <span class="label">Has Exit Taxes GP Call</span>
    @if (readOnly !== true) {
      <nullable-boolean
        [value]="terms.has_exit_taxes_gp_call"
        (valueChange)="terms.has_exit_taxes_gp_call = $event"
      name="has_exit_taxes_gp_call"></nullable-boolean>
    }
    <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: {
                  value:
                    terms.has_exit_taxes_gp_call === null
                      ? ''
                      : terms.has_exit_taxes_gp_call
                      ? 'Yes'
                      : 'No'
                }
              "></ng-container>
</li>
<li>
  <span class="label">Prep Fee Type</span>
  <select name="prep_fee_type" [(ngModel)]="terms.prep_fee_type" [disabled]="readOnly === true">
    <option [value]="null">&mdash;</option>
    <option value="gross">Gross</option>
    <option value="net">Net</option>
  </select>
</li>
<li>
  <span class="label">GP Prep Fee Percent</span>
  @if (readOnly !== true) {
    <input
      type="number"
      name="gp_prep_fee_pct"
      [(ngModel)]="terms.gp_prep_fee_pct" />
  }
  <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: {
                  value: terms.gp_prep_fee_pct
                    ? terms.gp_prep_fee_pct + '%'
                    : terms.gp_prep_fee_pct
                }
              "></ng-container>
</li>
<li>
  <span class="label">Year 11 GP Put Option</span>
  @if (readOnly !== true) {
    <input
      type="text"
      name="year_11_gp_call_option"
      [(ngModel)]="terms.year_11_gp_call_option" />
  }
  <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: { value: terms.year_11_gp_call_option }
              "></ng-container>
</li>
<li>
  <span class="label">Year 11 GP Call Months</span>
  @if (readOnly !== true) {
    <input
      type="number"
      name="year_15_gp_call_months"
      [(ngModel)]="terms.year_11_gp_call_months" />
  }
  <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: { value: terms.year_11_gp_call_months }
              "></ng-container>
</li>
<li>
  <span class="label">Year 11 GP Start</span>
  <ng-container
              *ngTemplateOutlet="
                valueSpan;
                context: { value: terms.year_11_gp_start_COMPUTE | date: 'MM/dd/yyyy' }
              "></ng-container>
</li>
<li>
  <span class="label">Year 11 GP End</span>
  <ng-container
              *ngTemplateOutlet="
                valueSpan;
                context: { value: terms.year_11_gp_end_COMPUTE | date: 'MM/dd/yyyy' }
              "></ng-container>
</li>
<li>
  <span class="label">Year 15 GP Put Option</span>
  @if (readOnly !== true) {
    <input
      type="text"
      name="year_15_gp_call_option"
      [(ngModel)]="terms.year_15_gp_call_option" />
  }
  <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: { value: terms.year_15_gp_call_option }
              "></ng-container>
</li>
<li>
  <span class="label">Year 15 GP Call Months</span>
  @if (readOnly !== true) {
    <input
      type="number"
      name="year_15_gp_call_months"
      [(ngModel)]="terms.year_15_gp_call_months" />
  }
  <ng-container
              *ngTemplateOutlet="
                readOnly === true ? valueSpan : nothing;
                context: { value: terms.year_15_gp_call_months }
              "></ng-container>
</li>
<li>
  <span class="label">Year 15 GP Start</span>
  <ng-container
              *ngTemplateOutlet="
                valueSpan;
                context: { value: terms.year_15_gp_start_COMPUTE | date: 'MM/dd/yyyy' }
              "></ng-container>
</li>
<li>
  <span class="label">Year 15 GP End</span>
  <ng-container
              *ngTemplateOutlet="
                valueSpan;
                context: { value: terms.year_15_gp_end_COMPUTE | date: 'MM/dd/yyyy' }
              "></ng-container>
</li>
</ul>
</form>
}
</mat-card-content>
</mat-card>
}
</ng-template>
<ng-template let-value="value" #valueSpan>
  @if (value?.length) {
    <span class="value">{{ value }}</span>
  } @else {
    <span class="value">&mdash;</span>
  }
</ng-template>
<ng-template #nothing></ng-template>
